<template lang="pug">
  div
    index(@handlePlayerInfo="handlePlayerInfo" @setLiveName="setLiveName" v-if="showIndex")
    div#app(:class="[layoutClassName]" ref="app" v-if="isLoaded")
      div#header
        comp-header(v-if="!$isMobile")
        comp-header-mobile(v-if="$isMobile")
      div#content
        div#player
          comp-player(v-if="!$isMobile" ref="player")
          comp-player-mobile(v-if="$isMobile" ref="player")
        div#message
          comp-message(ref="message"
            :isMobileVerticalLayout="isMobileVerticalLayout"
            :isMobileHorizontalLayout="isMobileHorizontalLayout")
</template>

<script>
// import LibGenerateTestUserSig from '@/utils/lib-generate-test-usersig.min.js';
import compHeader from '@/components/comp-header/index';
import compHeaderMobile from '@/components/comp-header/index-mobile';
import compPlayer from '@/components/comp-player/index';
import compPlayerMobile from '@/components/comp-player/index-mobile';
import compMessage from '@/components/comp-message';
import index from '@/views/index';
import layout from './layout.js';
import {
  SET_SDK_APP_ID,
  SET_USER_SIG,
  SET_PLAYER_DOMAIN,
  SET_ROOM_ID,
  SET_ROOM_NAME,
  UPDATE_USER_INFO,
  SET_ANCHOR_USER_ID,
  SET_IS_SUPPORT_WEBRTC,
  UPDATE_LINE_TYPE,
  SET_PRIVILEGEMAP,
} from '@/constants/mutation-types';
import {
  LINE_TYPE,
} from '@/constants/room';
import {
  sdkAppId,
  playerDomain,
  BASE_CONFIG,
} from '@/config/basic-info-config';
import { mapState } from 'vuex';
import TRTC from 'trtc-js-sdk';
import { getSecretKey, getUserInfo, markReq } from '@/utils/common.js';
import { isAndroid } from '@/utils/utils.js';
import io from '@/assets/js/socket.io.js';
export default {
  name: 'App',
  mixins: [layout],
  data() {
    return {
      isLoaded: false,
      showIndex: true,
    };
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
      roomId: 'roomId',
    }),
  },
  components: {
    index,
    compHeader,
    compPlayer,
    compMessage,
    compHeaderMobile,
    compPlayerMobile,
  },
  methods: {
    async socketReq() {
      const users = await getUserInfo();
      console.log('聊天===>', BASE_CONFIG.wssURL);
      const socket = io.connect(BASE_CONFIG.wssURL, { path: '/kronoswss', transports: ['websocket'] });
      window.socket = socket;
      socket.on('error', (err) => {
        console.log(err);
      });
      socket.on('destory', () => {
        this.handlerLive('直播已结束');
        socket.close();
      });
      socket.on('anchorleave', () => {
        this.handlerLive('直播暂停中，请稍后。');
        socket.close();
      });
      socket.on("connect", () => {
        console.log({ liveId: users.liveId, userId: users.userId }); // true
        socket.emit('join', { liveId: users.liveId, userId: users.userId });
      });
    },
    handlerLive(msg, type = 'info') {
      this.$message[type](msg);
      setTimeout(() => {
        this.handleLogout();
      }, 3000);
    },
    checkUserName(name) {
      const patt = /^\d{11}$/;
      if (patt.test(name)) {
        return name.replace(/(\d{3})(\d+)(\d{4})/, '$1****$2');
      }
      return (name && decodeURIComponent(name)) || '观众';
    },
    handlerLiveName(name) {
      if (name) return decodeURIComponent(name);
      return sessionStorage.getItem('liveName');
    },
    async enterRoom(data) {
    // 处理页面数据
      await this.handlePlayerInfo(data);
      // 判断是否支持 webrtc, 不支持 webrtc 的网页采用【线路三：标准直播】播放，且不可切换线路
      this.handleSupportWebRTC();
    // 处理监听事件
    },
    // 处理是否支持 webRTC
    async handleSupportWebRTC() {
      const supportResult = await TRTC.checkSystemRequirements();
      const { isWebRTCSupported, isH264DecodeSupported } = supportResult.detail;
      if (!isWebRTCSupported || !isH264DecodeSupported) {
        this.$store.commit(SET_IS_SUPPORT_WEBRTC, false);
        this.$store.commit(UPDATE_LINE_TYPE, LINE_TYPE.CDN);
      }
    },
    // 处理页面数据
    async handlePlayerInfo(data) {
      let userSig = '';
      const res = await getSecretKey(data);
      const users = await getUserInfo();
      if (res.code === '0000') {
        if (res.data.errorCode !== '0000') {
          this.handlerLive(res.data.errorMessage, 'error');
          return;
        }
        this.socketReq();
        userSig = res.data.sign;
        sessionStorage.setItem('password', JSON.stringify(data));
      }
      // alert(JSON.stringify(res.data, null, 2));
      // 注意：请优先设置 sdkAppId 信息
      sessionStorage.setItem('privatekey', res.data.privilegeMap);
      this.$store.commit(SET_SDK_APP_ID, sdkAppId);
      this.$store.commit(SET_USER_SIG, userSig);
      this.$store.commit(SET_PLAYER_DOMAIN, playerDomain);
      this.$store.commit(SET_PRIVILEGEMAP, res.data.privilegeMap);
      this.$store.commit(SET_ROOM_ID, users.liveId);
      this.$store.commit(SET_ROOM_NAME, this.handlerLiveName(users.liveName));
      this.$store.commit(SET_ANCHOR_USER_ID, res.data.userId);
      this.$store.commit(UPDATE_USER_INFO, {
        userId: res.data.userId,
        userName: this.checkUserName(users.userName),
        userAvatar: users.userAvatar,
      });
      this.isLoaded = true;
      this.showIndex = false;
      this.markLive(users);
    },
    setLiveName(name) {
      this.$store.commit(SET_ROOM_NAME, name);
    },
    // 退出直播间
    async handleExit() {
      // todo: 处理退出直播间
      const users = await getUserInfo();
      sessionStorage.removeItem('password');
      if (users.from) {
        !isAndroid && window.webkit.messageHandlers.outRoom.postMessage('');
        isAndroid && window.live && window.live.outRoom();
        return;
      }
      this.isLoaded = false;
      this.showIndex = true;
    },
    // 退出登录
    async handleLogout() {
      // todo: 处理退出登录
      const users = await getUserInfo();
      sessionStorage.removeItem('password');
      if (users.from) {
        !isAndroid && window.webkit.messageHandlers.outRoom.postMessage('');
        isAndroid && window.live && window.live.outRoom();
        return;
      }
      this.isLoaded = false;
      this.showIndex = true;
    },
    async markLive(users) {
      await markReq(users.liveId, users.userId);
    },
  },
  async created() {
    const pwd = sessionStorage.getItem('password');
    const users = await getUserInfo();
    if (pwd || users.password) {
      this.showIndex = false;
      const param = users.password === 'password' ? pwd ? JSON.parse(pwd) : { password: ''} : { password: users.password };
      this.enterRoom(param);
    }
    this.$eventBus.$on('exit', this.handleExit);
    this.$eventBus.$on('logout', this.handleLogout);
    this.$eventBus.$on('showLoginCard', this.handleShowLoginCard);
    // this.markLive(users);
  },
  beforeDestroy() {
    this.$eventBus.$off('exit', this.handleExit);
    this.$eventBus.$off('logout', this.handleLogout);
    this.$eventBus.$off('showLoginCard', this.handleShowLoginCard);
  },
};
</script>

<style lang="stylus">
@import '~assets/style/black-element-ui.styl';
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  width 100%
  height 100vh
  position relative
  text-align center
  overflow auto

// PC页面布局
#app.app-layout
  background-color $backgroundColor
  color $fontColor
  #header
    width 100%
    height 52px
    background-color $themeColor
  #content
    width 100%
    position absolute
    left 0
    bottom 0
    top 52px
    display flex
    #player
      height 100%
      flex-grow 1
      background-color $backgroundColor
    #message
      width 30%
      min-width 300px
      max-width 406px
      height 100%
      background-color $IMThemeColor

// 移动端竖屏布局
#app.mobile-vertical-layout
  background-color $IMThemeColor
  color $fontColor
  display flex
  flex-direction column
  #header
    width 100%
    max-height 130px
  #content
    flex-grow 1
    display flex
    flex-direction column
    #player
      width 100%
      height 250px
      background-color $backgroundColor
    #message
      background-color $IMThemeColor
      flex-grow 1
      position relative

// 移动端横屏布局
#app.mobile-horizontal-layout
  color $fontColor
  #header
    width 100%
    position absolute
    top 0
    left 0
    z-index 10
    transform translateZ(100px)
  #content
    width 100%
    height 100%
    position relative
    #player
      width 100%
      height 100%
      background-color $backgroundColor
    #message
      position absolute
      bottom 0
      left 0
      width 100%
      height 70%
      pointer-events none
      transform translateZ(100px)
</style>
